// extracted by mini-css-extract-plugin
module.exports = {"back_to_top":"styles_back_to_top__3b2H8","icon":"styles_icon__2_vYc","scrollTop":"styles_scrollTop__1uSio"};